export default "__VITE_ASSET__b861cb66__"